"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _scenicSpot = require("@/api/scenic-spot");
var _permission = require("@/utils/permission");
var _vuex = require("vuex");
var _storeEdit = _interopRequireDefault(require("./components/storeEdit"));
var _productTpye = _interopRequireDefault(require("./components/productTpye.vue"));
var _productEnums = require("@/enums/productEnums");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _useProduct2 = require("@/hooks/use-product");
var _public = require("@/libs/public");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _useProduct = (0, _useProduct2.useProduct)(),
  productTypeList = _useProduct.productTypeList;
var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  cateId: '',
  keywords: '',
  type: '1',
  categoryId: null,
  isPaidMember: null,
  productType: null
};
var _default = exports.default = {
  name: 'yearcardList',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        });
      }
    }
  },
  components: {
    storeEdit: _storeEdit.default,
    productTpye: _productTpye.default
  },
  data: function data() {
    return {
      productTypeList: productTypeList,
      //门票类型
      drawer: false,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: Object.assign({}, tableFroms),
      keywords: '',
      categoryList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '缩略图', '所属景点', '年卡名称', '市场价', '销售价', '生效时间段'],
      columnData: ['ID', '缩略图', '所属景点', '年卡名称', '市场价', '销售价', '生效时间段'],
      isIndeterminate: true,
      productId: 0,
      stockEdit: false,
      multipleSelectionAll: [],
      checkedIds: [],
      //选中的id

      loadingBtn: false,
      productInfo: null,
      //门票详情
      productType: 0,
      //门票类型
      isSub: false //佣金设置是否单独设置
    };
  },
  computed: _objectSpread({
    ProductTypeEnum: function ProductTypeEnum() {
      return _productEnums.ProductTypeEnum;
    },
    //操作上下架禁用
    IsShow: function IsShow() {
      return this.tableFrom.type == _productEnums.ProductTypeEnum.RecycleBin || this.tableFrom.type == _productEnums.ProductTypeEnum.Audit || this.tableFrom.type == _productEnums.ProductTypeEnum.ReviewFailed || this.tableFrom.type == _productEnums.ProductTypeEnum.PendingReview;
    },
    //已售罄或者警戒库存
    SoldOutAndAlertInventory: function SoldOutAndAlertInventory() {
      return this.tableFrom.type == this.ProductTypeEnum.SoldOut || this.tableFrom.type == this.ProductTypeEnum.AlertInventory;
    },
    //已售罄、警戒库存操作判断
    operation: function operation() {
      return this.tableFrom.type == this.ProductTypeEnum.SoldOut || this.tableFrom.type == this.ProductTypeEnum.AlertInventory;
    },
    //加入回收站 操作
    RecycleBin: function RecycleBin() {
      return this.tableFrom.type == this.ProductTypeEnum.Audit || this.tableFrom.type == this.ProductTypeEnum.ReviewFailed || this.tableFrom.type === _productEnums.ProductTypeEnum.InTheWarehouse || this.tableFrom.type === _productEnums.ProductTypeEnum.PendingReview;
    }
  }, (0, _vuex.mapGetters)(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  activated: function activated() {
    this.getList(1);
  },
  mounted: function mounted() {
    //  票务类型
    this.tableFrom.ticketType = 3;
    if ((0, _permission.checkPermi)(['merchant:product:page:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //提交审核
    handlePendingReview: function handlePendingReview(row) {
      var _this = this;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个门票');
      if (!row) {
        this.$modalSure("\u786E\u5B9A\u8981\u5C06\u6B64\u95E8\u7968\u63D0\u4EA4\u5E73\u53F0\u5BA1\u6838\u5417\uFF1F").then(function () {
          productBatchAuditApi({
            idList: _this.checkedIds
          }).then(function () {
            _this.$message.success('批量提交审核成功');
            _this.getList('');
          });
        });
      } else {
        this.$confirm('提审之后是否自动上架？', '提示', {
          confirmButtonText: '上架',
          cancelButtonText: '不用了',
          type: 'warning',
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          customClass: 'deleteConfirm'
        }).then(function () {
          _this.productAudit({
            id: row.id,
            isAutoUp: true
          });
        }).catch(function (action) {
          if (action === 'cancel') {
            _this.productAudit({
              id: row.id,
              isAutoUp: false
            });
            // 调用取消按钮的方法
          } else if (action === 'close') {
            console.log('Closed');
            // 调用关闭按钮的方法
          }
        });
      }
    },
    //提审提交
    productAudit: function productAudit(data) {
      var _this2 = this;
      productAuditApi(data).then(function (res) {
        _this2.getList();
      });
    },
    //批量加入回收站
    handleRecycleBin: function handleRecycleBin(type) {
      var _this3 = this;
      if (this.checkedIds.length === 0) return this.$message.warning('请至少选择一个门票');
      this.$modalSure(type == 5 ? "\u786E\u5B9A\u6279\u91CF\u5220\u9664\u95E8\u7968\u5417\uFF1F" : "\u786E\u5B9A\u6279\u91CF\u52A0\u5165\u56DE\u6536\u7AD9\u5417\uFF1F").then(function () {
        if (type == 5) {
          _this3.onBatchDelete();
        } else {
          _this3.onBatchRecycle();
        }
      });
    },
    //批量删除
    onBatchDelete: function onBatchDelete() {
      var _this4 = this;
      productBatchDeleteApi({
        idList: this.checkedIds
      }).then(function () {
        _this4.$message.success('批量删除成功');
        _this4.tableFrom.page = _this4.tableFrom.page - 1;
        _this4.delSuccess();
      });
    },
    //批量加入回收站
    onBatchRecycle: function onBatchRecycle() {
      var _this5 = this;
      productBatchRecycleApi({
        idList: this.checkedIds
      }).then(function () {
        _this5.$message.success('批量加入回收站成功');
        _this5.tableFrom.page = _this5.tableFrom.page - 1;
        _this5.delSuccess();
      });
    },
    // 删除成功
    delSuccess: function delSuccess() {
      (0, _public.handleDeleteTable)(this.tableData.data.length, this.tableFrom);
      this.getList();
    },
    //添加门票
    handleAdd: function handleAdd(row, type) {
      var id = row ? row.id : '0';
      var types = type ? type : 2;
      this.$router.push({
        path: "/scenic-spot/list/creatProduct/addyear/".concat(id, "/").concat(types)
      });
    },
    //批量下架
    batchDelisting: function batchDelisting(type) {
      var _this6 = this;
      if (this.checkedIds.length === 0) return this.$message.warning('请至少选择一个门票');
      if (type === 'down') {
        this.$modalSure('确定要将选中门票批量下架吗?').then(function () {
          productBatchDownApi({
            idList: _this6.checkedIds
          }).then(function () {
            _this6.$message.success('批量下架成功');
            _this6.getList(1);
          });
        });
      } else {
        this.$modalSure('确定要将选中门票批量上架吗?').then(function () {
          productBatchUpApi({
            idList: _this6.checkedIds
          }).then(function () {
            _this6.$message.success('批量上架成功');
            _this6.getList(1);
          });
        });
      }
    },
    // 设置选中的方法
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelectionAll = val;
      var data = [];
      this.multipleSelectionAll.map(function (item) {
        data.push(item.id);
      });
      this.checkedIds = data;
    },
    selectAll: function selectAll(data) {
      var id = data.map(function (i, index) {
        return i.id;
      });
      this.checkedIds = Array.from(new Set([].concat(_toConsumableArray(this.checkedIds), _toConsumableArray(id))));
    },
    selectOne: function selectOne(data, row) {
      var id = data.map(function (i, index) {
        return i.id;
      });
      var index = this.checkedIds.findIndex(function (e) {
        return e == row.id;
      });
      this.checkedIds.splice(index, 1);
      this.checkedIds = Array.from(new Set([].concat(_toConsumableArray(this.checkedIds), _toConsumableArray(id))));
    },
    handleEdit: function handleEdit(row, stockEdit) {
      this.productId = row.id;
      this.productType = row.type;
      this.isSub = row.isSub;
      this.drawer = true;
      this.stockEdit = stockEdit;
    },
    handleCloseEdit: function handleCloseEdit() {
      this.drawer = false;
    },
    handleAudit: function handleAudit(id) {
      var _this7 = this;
      this.$confirm('提审之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(function () {
        _this7.productAudit({
          id: id,
          isAutoUp: true
        });
      }).catch(function () {
        _this7.productAudit({
          id: id,
          isAutoUp: false
        });
      });
    },
    //恢复门票
    handleRestore: function handleRestore(row) {
      var _this8 = this;
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个门票');
      this.$modalSure(!row ? '确定批量恢复门票吗？' : '确定恢复门票吗？').then(function () {
        if (row) {
          restoreApi(row.id).then(function (res) {
            _this8.$message.success('恢复门票成功');
            _this8.getList(1);
          });
        } else {
          productBatchRestoreApi({
            idList: _this8.checkedIds
          }).then(function (res) {
            _this8.$message.success('批量恢复门票成功');
            _this8.getList(1);
          });
        }
      });
    },
    handleSeachList: function handleSeachList() {
      this.getList(1);
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.cateId = '';
      this.tableFrom.keywords = '';
      this.tableFrom.categoryId = '';
      this.tableFrom.isPaidMember = null;
      this.tableFrom.productType = null;
      this.keywords = '';
      this.handleSeachList();
    },
    // 导出
    exports: function exports() {
      productExcelApi({
        cateId: this.tableFrom.cateId,
        keywords: this.tableFrom.keywords,
        type: this.tableFrom.type
      }).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 列表
    getList: function getList(num) {
      var _this9 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      this.tableFrom.name = this.keywords;
      (0, _scenicSpot.ticketLstApi)(this.tableFrom).then(function (res) {
        _this9.tableData.data = res.list;
        _this9.tableData.total = res.total;
        _this9.listLoading = false;
      }).catch(function (res) {
        _this9.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //详情
    handleInfo: function handleInfo(id, type) {
      this.$router.push({
        path: "/product/list/creatProduct/".concat(id, "/2/2/").concat(type)
      });
    },
    // 删除
    handleDelete: function handleDelete(row, type) {
      var _this0 = this;
      this.$modalSure("\u662F\u5426\u5220\u9664".concat(row.name, "\u5E74\u5361")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        (0, _scenicSpot.ticketDeleteApi)(row.id).then(function () {
          _this0.$message.success('删除成功');
          _this0.delSuccess();
        });
      });
      // this.$modalSure(type == 5 ? `删除 id 为 ${id} 的门票` : `id为${id}的门票加入回收站吗`).then(() => {
      //   const deleteFlag = type == 5 ? 'delete' : 'recycle';
      //   ticketDeleteApi({
      //     id: row.id,
      //
      //   }).then(() => {
      //     this.$message.success('删除成功');
      //     this.delSuccess();
      //   });
      // });
    },
    // 隐藏
    handleyc: function handleyc() {},
    onchangeIsShow: function onchangeIsShow(row) {
      var _this1 = this;
      row.isShow ? putOnShellApi(row.id).then(function () {
        _this1.$message.success('上架成功');
        _this1.getList(1);
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : offShellApi(row.id).then(function () {
        _this1.$message.success('下架成功');
        _this1.getList(1);
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('goods_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};